import GiftList from './gift-list'
export default GiftList